var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 7H11","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
